import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {RoleState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class RoleQuery extends QueryEntity<RoleState> {

  constructor(protected store: Store) {
    super(store);
  }

}
